// extracted by mini-css-extract-plugin
export default {"section":"Home_section__QCmkO","about":"Home_about__NzfNu","service":"Home_service__CV7YP"};